import { getAdminApplicationCode, getApplicationAccess, getApplicationCode, getApplicationsFromSession } from '../../utils/permisos'

export const getUserAvailableApplications = (session) => (
  getApplicationsFromSession(session).filter((access) => access?.application?.active !== false)
)

export const getUserApplicationCodes = (session) => (
  getUserAvailableApplications(session)
    .map(getApplicationCode)
    .filter(Boolean)
)

export const getUserApplicationSummaries = (session) => (
  getUserAvailableApplications(session).map((access) => {
    const application = access?.application || access
    const code = getApplicationCode(access)

    return {
      id: application?.id || code,
      code,
      title: application?.name || code || 'Aplicacion',
      description: application?.description || `Acceso habilitado a ${application?.name || code}.`,
      url: application?.url || application?.basePath || null,
      imageUrl: application?.imageUrl || application?.image_url || null,
      icon: application?.icon || null,
      displayOrder: application?.display_order ?? application?.displayOrder ?? 0,
      status: access?.active === false || application?.active === false ? 'Inactiva' : 'Disponible',
      permissions: access?.permissions || [],
      roles: access?.roles || [],
      warehouseScope: access?.warehouseScope,
    }
  })
)

// Sidebar y accesos rápidos comparten exclusivamente las asignaciones de la sesión.
export const getAssignedApplicationLinks = (session) => {
  const adminCode = String(getAdminApplicationCode(session) || '').toUpperCase()

  return getUserApplicationSummaries(session)
    .filter((application) => application.status !== 'Inactiva')
    .filter((application) => String(application.code).toUpperCase() !== adminCode)
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map((application) => ({
      ...application,
      path: application.url || `/apps/${String(application.code || 'aplicacion').trim().toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-')}`,
      external: /^https?:\/\//i.test(String(application.url || '')),
    }))
}

export const hasUserApplication = (session, applicationCode) => (
  Boolean(getApplicationAccess(session, applicationCode))
)

export const hasUserLogisticsAccess = (session) => (
  getUserAvailableApplications(session).some((access) => {
    const application = access?.application || access
    const code = getApplicationCode(access).toLowerCase()
    const name = String(application?.name || '').toLowerCase()
    const url = String(application?.url || application?.basePath || '').toLowerCase()

    return code.includes('logistic') || name.includes('logistica') || url.includes('logistic')
  })
)
